import { axiosBase, errorHandler } from "./axios";

const getFeeParams = (data: any) => {
  return axiosBase.get("fee/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const createFee = (data: any) => {
  return axiosBase.post("fee/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const deleteFee = (data: any) => {
  return axiosBase.delete(`fee/delete/${data}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getFeeView = (data: any) => {
  const id = typeof data === 'string' ? data : data.id;
  return axiosBase.get(`fee/view/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getStudentFeeSummary = (studentId: string, params?: { serviceId?: string; enrollmentId?: string }) => {
  return axiosBase.get(`fee/student/${studentId}/summary`, { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getEnrollmentFeeHistory = (data: { enrollmentId: string; studentId: string }) => {
  return axiosBase.get('fee/list', { params: { ...data, pageSize: 100 } })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const exportFee = (data: any) => {
  return axiosBase.get('fee/export', {
    params: data,
    responseType: 'blob',
  })
    .then((response) => response)
    .catch((error) => errorHandler(error));
}

export const feeService = {
  getFeeParams,
  createFee,
  deleteFee,
  getFeeView,
  getStudentFeeSummary,
  getEnrollmentFeeHistory,
  exportFee,
};
